<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
		<b-card>
			<b-row>
				<b-col cols="12">
					<app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
				</b-col>
			</b-row>
			<b-row v-if="isUploadSuccess">
				<b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Approval Configuration Instance" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="approvalConfigurationInstancePageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="approvalConfigurationInstances" :fields="fieldsApprovalConfigurationInstance" :busy="isDataLoading" :sort-by.sync="sortByApprovalConfigurationInstance" :sort-desc.sync="sortDescApprovalConfigurationInstance" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowApprovalConfigurationInstanceFilter = !isShowApprovalConfigurationInstanceFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowApprovalConfigurationInstanceFilter">
										<b-th></b-th>
										<b-th stacked-heading="Name">
											<b-form-input id="input-name-table" v-model="filterApprovalConfigurationInstance.name" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Approval Instance">
											<b-form-input id="input-approval-instance-table" v-model="filterApprovalConfigurationInstance.approvalInstance" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Approval Type">
											<v-select append-to-body label="name" :options="approvalTypes" :value="filterApprovalConfigurationInstance.approvalTypeId"  :reduce="item => item.id" v-model="filterApprovalConfigurationInstance.approvalTypeId" @search="getApprovalTypes" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Description">
											<b-form-input id="input-description-table" v-model="filterApprovalConfigurationInstance.description" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Applied To">
											<v-select append-to-body label="name" :options="appliedTos" :value="filterApprovalConfigurationInstance.appliedToId"  :reduce="item => item.id" v-model="filterApprovalConfigurationInstance.appliedToId" @search="getAppliedTos" :filterable="true"></v-select>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( approvalConfigurationInstancePageSize * (currentApprovalConfigurationInstancePage - 1))) }}
									</template>
									<template v-slot:cell(approvalType)="row">
										{{ row.item.approvalType != null ? row.item.approvalType.name : "" }}
									</template>
									<template v-slot:cell(appliedTo)="row">
										{{ row.item.appliedTo != null ? row.item.appliedTo.name : "" }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentApprovalConfigurationInstancePage"
									:total-rows="totalApprovalConfigurationInstanceRow"
									:per-page="approvalConfigurationInstancePageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
							<b-tab title="Approval Configuration Instance Detail" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="approvalConfigurationInstanceDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="approvalConfigurationInstanceDetails" :fields="fieldsApprovalConfigurationInstanceDetail" :busy="isDataLoading" :sort-by.sync="sortByApprovalConfigurationInstanceDetail" :sort-desc.sync="sortDescApprovalConfigurationInstanceDetail" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowApprovalConfigurationInstanceDetailFilter = !isShowApprovalConfigurationInstanceDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowApprovalConfigurationInstanceDetailFilter">
										<b-th></b-th>
										<b-th>
										</b-th>
										<b-th stacked-heading="Approver Type">
											<v-select append-to-body label="name" :options="approverTypes" :value="filterApprovalConfigurationInstanceDetail.approverTypeId"  :reduce="item => item.id" v-model="filterApprovalConfigurationInstanceDetail.approverTypeId" @search="getApproverTypes" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approval Structure">
											<v-select append-to-body label="name" :options="approvalStructures" :value="filterApprovalConfigurationInstanceDetail.approvalStructureId"  :reduce="item => item.id" v-model="filterApprovalConfigurationInstanceDetail.approvalStructureId" @search="getApprovalStructures" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approver Level">
											<b-form-input id="input-approver-level-table" v-model="filterApprovalConfigurationInstanceDetail.approverLevel" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Approver User Name">
											<v-select append-to-body label="firstName" :options="userInfos" :value="filterApprovalConfigurationInstanceDetail.approverUserNameId"  :reduce="item => item.id" v-model="filterApprovalConfigurationInstanceDetail.approverUserNameId" @search="getUserInfos" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Stored Procedure Name">
											<b-form-input id="input-stored-procedure-name-table" v-model="filterApprovalConfigurationInstanceDetail.storedProcedureName" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Approval Type">
											<b-form-input id="input-approval-type-table" v-model="filterApprovalConfigurationInstanceDetail.approvalType" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Configuration Content">
											<b-form-input id="input-configuration-content-table" v-model="filterApprovalConfigurationInstanceDetail.configurationContent" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Is Send Notification">
											<b-form-checkbox id="input-is-send-notification-table" @change="getApprovalConfigurationInstanceDetails" class="float-right" v-model="filterApprovalConfigurationInstanceDetail.isSendNotification"></b-form-checkbox>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( approvalConfigurationInstanceDetailPageSize * (currentApprovalConfigurationInstanceDetailPage - 1))) }}
									</template>
									<template v-slot:cell(approvalConfigurationInstance)="row">
										{{ row.item.approvalConfigurationInstance != null ? row.item.approvalConfigurationInstance.name : "" }}
									</template>
									<template v-slot:cell(approverType)="row">
										{{ row.item.approverType != null ? row.item.approverType.name : "" }}
									</template>
									<template v-slot:cell(approvalStructure)="row">
										{{ row.item.approvalStructure != null ? row.item.approvalStructure.name : "" }}
									</template>
									<template v-slot:cell(approverUserName)="row">
										{{ row.item.approverUserName != null ? row.item.approverUserName.firstName : "" }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentApprovalConfigurationInstanceDetailPage"
									:total-rows="totalApprovalConfigurationInstanceDetailRow"
									:per-page="approvalConfigurationInstanceDetailPageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
		</b-card>
		<template #modal-footer="{ ok, cancel }">
			<b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
				Download Log
			</b-button>
			<b-button size="sm" variant="success" class="float-right" @click="ok()">
				{{ okTitle }}
			</b-button>
			<b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
				Cancel
			</b-button>
		</template>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
.card {
	border: 1px solid rgba(0, 0, 0, 0.125) !important;
}
::v-deep.th-message {
	color: red;
}
::v-deep.modal-footer {
	display: block;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate"; 
import { required, minLength } from "vuelidate/lib/validators"; 
import { saveAs } from 'file-saver';

import ApprovalConfigurationInstance from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstance';
import ApprovalConfigurationInstanceList from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceList';
import ApprovalConfigurationInstanceFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceFilter';

import ApprovalType from '@/models/ApprovalType/ApprovalType';
import ApprovalTypeFilter from '@/filters/ApprovalType/ApprovalTypeFilter';
import AppliedTo from '@/models/AppliedTo/AppliedTo';
import AppliedToFilter from '@/filters/AppliedTo/AppliedToFilter';
import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';
import ApprovalConfigurationInstanceDetailFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
// import UserInfo from '@/models/PrivilegeManagement/UserInfo';
// import UserInfoFilter from '@/filters/PrivilegeManagement/UserInfoFilter';
import AppInputFileupload from '@/components/AppInputFileupload';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,AppInputDatetimepicker,AppInputDatetimepickerRange,},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fieldsApprovalConfigurationInstance: [
				{"no" : { "class" : "th-number"}}, 
				{"name": { "class" : "th-name", "label" : "Name"}, key: 'name', sortable: true}, 
				{"approvalInstance": { "class" : "th-approval-instance", "label" : "Approval Instance"}, key: 'approvalInstance', sortable: true}, 
				{"approvalType": { "class" : "th-approval-type", "label" : "Approval Type"}, key: 'approvalType', sortable: true}, 
				{"description": { "class" : "th-description", "label" : "Description"}, key: 'description', sortable: true}, 
				{"appliedTo": { "class" : "th-applied-to", "label" : "Applied To"}, key: 'appliedTo', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsApprovalConfigurationInstanceDetail: [
				{"no" : { "class" : "th-number"}}, 
				{"approvalConfigurationInstance": { "class" : "th-approval-configuration-instance", "label" : "ApprovalConfigurationInstance"}, key: 'approvalConfigurationInstance', sortable: true}, 
				{"approverType": { "class" : "th-approver-type", "label" : "Approver Type"}, key: 'approverType', sortable: true}, 
				{"approvalStructure": { "class" : "th-approval-structure", "label" : "Approval Structure"}, key: 'approvalStructure', sortable: true}, 
				{"approverLevel": { "class" : "th-approver-level", "label" : "Approver Level"}, key: 'approverLevel', sortable: true}, 
				{"approverUserName": { "class" : "th-approver-user-name", "label" : "Approver User Name"}, key: 'approverUserName', sortable: true}, 
				{"storedProcedureName": { "class" : "th-stored-procedure-name", "label" : "Stored Procedure Name"}, key: 'storedProcedureName', sortable: true}, 
				{"approvalType": { "class" : "th-approval-type", "label" : "Approval Type"}, key: 'approvalType', sortable: true}, 
				{"configurationContent": { "class" : "th-configuration-content", "label" : "Configuration Content"}, key: 'configurationContent', sortable: true}, 
				{"isSendNotification": { "class" : "th-is-send-notification", "label" : "Is Send Notification"}, key: 'isSendNotification', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isDataLoading: false,
			isBusy : false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			approvalConfigurationInstances : [],
			approvalConfigurationInstanceId : '',
			totalApprovalConfigurationInstanceRow : 0,
			isShowApprovalConfigurationInstanceFilter: false,
			filterApprovalConfigurationInstance : null,
			currentApprovalConfigurationInstancePage : 1,
			approvalConfigurationInstancePageSize: 10,
			sortByApprovalConfigurationInstance: '',
			sortDescApprovalConfigurationInstance: '',
			filterApprovalConfigurationInstanceDetail : null,
			currentApprovalConfigurationInstanceDetailPage : 1,
			approvalConfigurationInstanceDetailPageSize: 10,
			sortByApprovalConfigurationInstanceDetail: '',
			sortDescApprovalConfigurationInstanceDetail: '',
			sortingByApprovalConfigurationInstanceDetail: [],
			approvalConfigurationInstanceDetails : [],
			approvalConfigurationInstanceDetailId : '',
			totalApprovalConfigurationInstanceDetailRow : 0,
			isShowApprovalConfigurationInstanceDetailFilter: false,
			approvalConfigurationInstances: [],
			approverTypes: [],
			approvalStructures: [],
			userInfos: [],
			approvalTypes: [],
			appliedTos: [],
			processId: "",
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'approvalconfigurationinstance/confirmUpload',
					[],
					).then(async function(response){
						if (response != null) {
						if (response.data != null) {
							_this.resetModal();
							_this.datas = Array();
							_this.fileupload = null;
							_this.isUploadSuccess = false;
						}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
				let data = new FormData();
				data.append('file', this.fileupload);
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'approvalconfigurationinstance/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.isBusy = false;
						_this.isUploadSuccess = true;
						_this.getApprovalConfigurationInstances();
						_this.getApprovalConfigurationInstanceDetails();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getApprovalConfigurationInstances : async function() {
			let filter = {};
			Object.assign(filter, this.filterApprovalConfigurationInstance);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByApprovalConfigurationInstance = Array();
			if (this.sortByApprovalConfigurationInstance != null) {
				this.sortingByApprovalConfigurationInstance[this.sortByApprovalConfigurationInstance] = this.sortDescApprovalConfigurationInstance;
			}
			let currentPage = (this.currentApprovalConfigurationInstancePage - 1);
			ApprovalConfigurationInstance.getList(this, filter, this.sortingByApprovalConfigurationInstance, currentPage , this.approvalConfigurationInstancePageSize).then(result => {
				this.approvalConfigurationInstances = result.data;
				this.totalApprovalConfigurationInstanceRow = result.dataCount;
			}).catch(error => {});
		},
		getApprovalConfigurationInstanceDetails : async function() {
			let filter = {};
			Object.assign(filter, this.filterApprovalConfigurationInstanceDetail);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByApprovalConfigurationInstanceDetail = Array();
			if (this.sortByApprovalConfigurationInstanceDetail != null) {
				this.sortingByApprovalConfigurationInstanceDetail[this.sortByApprovalConfigurationInstanceDetail] = this.sortDescApprovalConfigurationInstanceDetail;
			}
			let currentPage = (this.currentApprovalConfigurationInstanceDetailPage - 1);
			ApprovalConfigurationInstanceDetail.getList(this, filter, this.sortingByApprovalConfigurationInstanceDetail, currentPage , this.approvalConfigurationInstanceDetailPageSize).then(result => {
				this.approvalConfigurationInstanceDetails = result.data;
				this.totalApprovalConfigurationInstanceDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalTypes : async function(input) {
			let filter = new ApprovalTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalTypes = result.data
				}
			})
			.catch(error => {});
		},
		getAppliedTos : async function(input) {
			let filter = new AppliedToFilter();
			if (input != undefined) {
				filter.name = input;
			}
			AppliedTo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.appliedTos = result.data
				}
			})
			.catch(error => {});
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowApprovalConfigurationInstanceDetailFilter = true;
			}
		},
		downloadLog() {
			let _this = this;
			this.$http.post(process.env.VUE_APP_API_URL + 'approvalconfigurationinstance/downloadlog', [],
			{ headers: { 'Content-Type': 'application/json' }}
			).then(async function(response){
				await saveAs(process.env.VUE_APP_API_URL + 'approvalconfigurationinstance/downloadlog', "ApprovalConfigurationInstance.xslx");
				_this.isBusy = false;
			})
			.catch(error => {
				_this.$store.dispatch('addErrorMessageGlobal', error);
				_this.isBusy = false;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		sortByApprovalConfigurationInstance : {
			handler: function() {
				this.getApprovalConfigurationInstances();
			}
		},
		sortDescApprovalConfigurationInstance: {
			handler: function() {
				this.getApprovalConfigurationInstances();
			}
		},
		currentApprovalConfigurationInstancePage: {
			handler: function() {
				this.getApprovalConfigurationInstances();
			}
		},
		approvalConfigurationInstancePageSize : {
			handler: function() {
				this.getApprovalConfigurationInstances();
			}
		},
		filterApprovalConfigurationInstance: {
			handler: function() {
				this.getApprovalConfigurationInstances();
			},
			deep: true,
		},
		sortByApprovalConfigurationInstanceDetail : {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		sortDescApprovalConfigurationInstanceDetail: {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		currentApprovalConfigurationInstanceDetailPage: {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		approvalConfigurationInstanceDetailPageSize : {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		filterApprovalConfigurationInstanceDetail: {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			},
			deep: true,
		},
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Proses";
				}
				return "Simpan";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterApprovalConfigurationInstance = new ApprovalConfigurationInstanceFilter();
					this.filterApprovalConfigurationInstanceDetail = new ApprovalConfigurationInstanceDetailFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
